// extracted by mini-css-extract-plugin
export default {"Editor":"index__Editor__aDaGB"};